module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('order-list', {
    attrs: {
      "orders": _vm.voidedOrders
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7506c762"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/orders/VoidedOrders.vue
// module id = 555
// module chunks = 0